// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pwyI","newExpiryDate":"styles_newExpiryDate__Uqkek","footer":"styles_footer__QIA9F"};